import {
  CalendarEventOrderInput,
  compareCalendarEventOrder,
  isGoalDeadlineEvent,
} from '@griply/utils';
import { ID } from 'shared/types/id';

type FullCalendarCompareObject = {
  extendedProps?: {
    completed?: unknown;
    externalId?: unknown;
    goalId?: unknown;
    taskId?: unknown;
  };
  // FullCalendar's seg-compare object: allDay arrives as Number(0|1), the event's publicId as `id`.
  id?: unknown;
  allDay?: unknown;
  start?: number;
  title?: string;
};

const toOrderInput = (raw: unknown): CalendarEventOrderInput => {
  const event = raw as FullCalendarCompareObject;
  const props = event.extendedProps ?? {};

  return {
    id: typeof event.id === 'string' ? event.id : '',
    isAllDay: !!event.allDay,
    isCompleted: !!props.completed,
    isExternal: !!props.externalId,
    isGoalDeadline: isGoalDeadlineEvent({
      goalId: props.goalId as ID | undefined,
      taskId: props.taskId as ID | undefined,
    }),
    start: typeof event.start === 'number' ? event.start : 0,
    title: event.title ?? '',
  };
};

// FullCalendar passes its internal seg-compare objects (extendedProps present,
// `start` as a millisecond number) to eventOrder, not EventApi instances.
export const eventOrder = (a: unknown, b: unknown): number =>
  compareCalendarEventOrder(toOrderInput(a), toOrderInput(b));
